import React from 'react';
import { Spinner } from '@salesforce/design-system-react/';
const Loading = () => {
  return (
    <div
      style={{
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <Spinner
        containerClassName="slds-color__background_gray-2"
        containerStyle={{ opacity: 0.5 }}
        size="large"
        variant="brand"
        assistiveText={{ label: 'Loading...' }}
      />
    </div>
  );
};

export default Loading;
